import { FormattedMessage, useIntl } from "react-intl";
import { PrintStatus } from "common/api/decimal/methods/course.ts";
import AssetCoverToast from "common/features/asset/AssetCoverToast";
import {
  optedOutWithoutBook,
  optedOutWithBook,
  isPickupDateInFuture,
} from "./printStatusHelper";

interface ToastProps {
  pickupDate: string | null;
  previousPrintStatus: PrintStatus | undefined;
  onClose?: () => void;
  vbid: string;
}

export default function ConfirmOptInPrintToast({
  pickupDate,
  previousPrintStatus,
  onClose,
  vbid,
}: ToastProps) {
  const intl = useIntl();
  const getTitle = () => {
    if (optedOutWithBook(previousPrintStatus)) {
      return intl.formatMessage({
        defaultMessage: "Your print book has been confirmed, you can keep it.",
      });
    } else if (optedOutWithoutBook(previousPrintStatus)) {
      if (isPickupDateInFuture(pickupDate)) {
        return intl.formatMessage(
          {
            defaultMessage:
              "Your print book has been confirmed and will be ready for pickup on {pickupDateAsDate, date, mm/dd/yyyy}.",
          },
          { pickupDateAsDate: new Date(pickupDate!) }
        );
      } else {
        return intl.formatMessage({
          defaultMessage:
            "Your print book has been confirmed and is ready to pick up at the bookstore.",
        });
      }
    } else {
      return null;
    }
  };

  return (
    <AssetCoverToast
      vbid={vbid}
      onClose={onClose}
      type="success"
      title={getTitle()}
    >
      <FormattedMessage defaultMessage="Billing will be updated in your student account." />
    </AssetCoverToast>
  );
}
